import { useSyncExternalStore } from 'react';

export type WorkspaceStatus =
  | { phase: 'initializing' }
  | { phase: 'local-ready'; persistence: 'ok' | 'degraded' }
  | { phase: 'sync-complete'; persistence: 'ok' | 'degraded' }
  | { phase: 'disconnected'; lastSync: Date | null }
  | { phase: 'initialization-failed'; error: Error };

let currentStatus: WorkspaceStatus = { phase: 'initializing' };
const listeners = new Set<() => void>();

export function setWorkspaceStatus(next: WorkspaceStatus): void {
  currentStatus = next;
  listeners.forEach((l) => l());
}

export function getWorkspaceStatus(): WorkspaceStatus {
  return currentStatus;
}

export function useWorkspaceStatus(): WorkspaceStatus {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => currentStatus,
    () => ({ phase: 'initializing' } as const),
  );
}
